<template>
  <div class="date-select">
    <div class="date-select-block" @click="toggle" v-if="current">{{current}}</div>
    <div class="date-select-block place-holder" @click="toggle" v-else>请选择</div>
    <transition name="fade" mode="out-in">
      <ucar-mask v-if="showSlider"></ucar-mask>
    </transition>
    <transition name="popup" mode="out-in">
      <div class="slider-wrapper" @touchmove.stop.prevent v-if="showSlider">
        <div class="slider-header">
          <div class="slider-cancel" @click="change(false)">取消</div>
          <div class="slider-tips" v-if="tips">{{tips}}</div>
          <div class="slider-conform" @click="change(true)">确定</div>
        </div>
        <div class="date-select-wrapper">
          <sliding-block
            @selectChange="changeYear"
            @click.stop
            :options="yearList"
            :value="currentYear"
          >
            <div class="slider-select"></div>
          </sliding-block>
          <sliding-block
            @selectChange="changeMonth"
            @click.stop
            :options="monthList"
            :value="currentMonth"
          >
            <div class="slider-select"></div>
          </sliding-block>
          <sliding-block
            @selectChange="changeDate"
            @click.stop
            :options="dateList"
            :value="currentDate"
          >
            <div class="slider-select"></div>
          </sliding-block>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.date-select {
  display: inline-block;
  flex: 1 0 0;
  height: 100%;
}

.date-select-block {
  position: relative;
  color: $ucar_font_color;
  text-align: right;
  padding-right: 40px;

  &::after {
    position: absolute;
    right: 5px;
    top: 50%;
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border-bottom: 2px solid $ucar_font_assist_color;
    border-right: 2px solid $ucar_font_assist_color;
    transform: translate3d(0, -50%, 0) rotate(-45deg);
    box-sizing: border-box;
  }
}

.date-select-block,
.place-holder {
  min-width: 0;
  font-size: $ucar_font_h4;
  height: 100%;
  line-height: 100px;
}

.place-holder {
  color: $ucar_font_assist_color;
}

.date-select-wrapper {
  display: flex;
  align-items: center;
}

.slider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-cancel,
.slider-conform {
  text-align: center;
  padding: 0 30px;
  font-size: 34px;
  line-height: 80px;
  height: 80px;
}

.slider-cancel {
  color: #666;
}

.slider-tips {
  font-size: 34px;
  font-weight: bold;
  color: $ucar_font_color;
  line-height: 80px;
  height: 80px;
  flex: 1 0 auto;
  min-width: 0;
  text-align: center;
}

.slider-conform {
  color: #ff9c00;
}

.slider-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 11;
  width: 100%;
  background-color: #fff;
}

.slider-select {
  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid #ddd; /*no*/
  height: 80px;
  border-bottom: 1px solid #ddd; /*no*/
  z-index: 1;
}
</style>

<script>
import UcarDate from 'ucar-date'
import slidingBlock from './sliding-block'

const leftZero = (num, length) => {
  const count = length - `${num}`.length
  if (count < 0) return `${num}`
  let arr = []
  for (let i = 0; i < count; i += 1) {
    arr.push('0')
  }
  return `${arr.join('')}${num}`
}

export default {
  data () {
    return {
      showSlider: false,
      current: '',
      yearList: [],
      currentYear: '',
      monthList: [],
      currentMonth: '',
      dateList: [],
      currentDate: '',
      maxDate: null,
      minDate: null
    }
  },
  components: {
    'sliding-block': slidingBlock
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    value: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    startDate: {
      type: [String, Date],
      default: () => {
        return new Date((new Date()).getFullYear() - 3, (new Date()).getMonth(), (new Date()).getDate())
      }
    },
    endDate: {
      type: [String, Date],
      default: () => {
        return new Date()
      }
    },
    from: {
      type: String,
      default: 'start'
    }
  },
  watch: {
    value () {
      this.$nextTick(this.init)
    },
    currentYear (val) {
      this.monthList = this.computeMonth()
      if (this.monthList.length === 0) {
        this.dateList = this.computeDate(`${this.val}-${this.currentMonth}-01`)
        return
      }
      const maxYear = leftZero(this.maxDate.year, 4)
      const minYear = leftZero(this.minDate.year, 4)
      const maxMonth = this.monthList[this.monthList.length - 1].value
      const minMonth = this.monthList[0].value
      if (val === maxYear && this.currentMonth > maxMonth) { this.currentMonth = maxMonth }
      if (val === minYear && this.currentMonth < minMonth) { this.currentMonth = minMonth }
      this.dateList = this.computeDate(`${this.val}-${this.currentMonth}-01`)
      if (this.dateList.length === 0) return
      const maxDate = this.dateList[this.dateList.length - 1].value
      const minDate = this.dateList[0].value
      if (val === maxYear && this.currentMonth === maxMonth && this.currentDate > maxDate) { this.currentDate = maxDate }
      if (val === minYear && this.currentMonth === minMonth && this.currentDate < minDate) { this.currentDate = minDate }
    },
    currentMonth (val) {
      const maxYear = leftZero(this.maxDate.year, 4)
      const minYear = leftZero(this.minDate.year, 4)
      const maxMonth = leftZero(this.maxDate.month, 2)
      const minMonth = leftZero(this.minDate.month, 2)
      this.dateList = this.computeDate(`${this.currentYear}-${val}-01`)
      if (this.dateList.length === 0) return
      const maxDate = this.dateList[this.dateList.length - 1].value
      const minDate = this.dateList[0].value
      if (this.currentYear === maxYear && val === maxMonth && this.currentDate > maxDate) { this.currentDate = maxDate }
      if (this.currentYear === minYear && val === minMonth && this.currentDate < minDate) { this.currentDate = minDate }
    }
  },
  methods: {
    computeDate (dataStr) {
      if (this.currentYear === '长期') return []
      const u = new UcarDate(dataStr)
      let end = u.getDaysOfMonth()
      let start = 1;
      const maxYear = leftZero(this.maxDate.year, 4)
      const minYear = leftZero(this.minDate.year, 4)
      const maxMonth = leftZero(this.maxDate.month, 2)
      const minMonth = leftZero(this.minDate.month, 2)
      if (
        this.currentYear === maxYear &&
        this.currentMonth === maxMonth
      ) {
        end = this.maxDate.date
      }
      if (
        this.currentYear === minYear &&
        this.currentMonth === minMonth
      ) {
        start = this.minDate.date
      }
      const arr = []
      for (let i = start; i <= end; i += 1) {
        arr.push({
          name: `${leftZero(i, 2)}日`,
          value: `${leftZero(i, 2)}`
        })
      }
      return arr
    },
    computeMonth () {
      if (this.currentYear === '长期') return []
      const monthList = []
      let end = 12
      let start = 1
      const maxYear = leftZero(this.maxDate.year, 4)
      const minYear = leftZero(this.minDate.year, 4)
      if (this.currentYear === maxYear) {
        end = this.maxDate.month
      }
      if (this.currentYear === minYear) {
        start = this.minDate.month
      }
      for (let i = start; i <= end; i += 1) {
        monthList.push({
          name: `${leftZero(i, 2)}月`,
          value: `${leftZero(i, 2)}`
        })
      }
      return monthList
    },
    toggle () {
      setTimeout(() => {
        this.showSlider = !this.showSlider
      }, 300)
    },
    changeDate (val) {
      this.currentDate = val.value
    },
    changeMonth (val) {
      this.currentMonth = val.value
    },
    changeYear (val) {
      this.currentYear = val.value
    },
    change (isComfirm) {
      this.showSlider = false
      if (!isComfirm) return
      const val = this.currentYear === '长期' ? this.currentYear : `${this.currentYear}-${this.currentMonth}-${this.currentDate}`
      this.$emit(
        'input',
        val
      )
    },
    init () {
      if (!this.value && this.value !== 0) return
      if (this.value !== '长期') {
        this.current = this.value
        let [year, month, date] = this.current.split('-')
        this.currentYear = year
        this.currentMonth = month
        this.currentDate = date
      } else {
        this.currentYear = '长期'
        this.current = this.currentYear
      }
    }
  },
  mounted () {
    this.maxDate = new UcarDate(this.endDate)
    this.minDate = new UcarDate(this.startDate)
    const end = this.maxDate.year
    const range = end - this.minDate.year
    const yearList = []
    for (let i = 0; i <= range; i += 1) {
      yearList.unshift({
        name: `${leftZero(end - i, 4)}年`,
        value: `${leftZero(end - i, 4)}`
      })
    }
    if (this.type === 'idCard') {
      yearList.push({
        name: '长期',
        value: '长期'
      })
    }
    this.yearList = yearList
    this.currentYear = this.from === 'start' ? this.yearList[0].value : this.yearList[this.yearList.length - 1].value
    this.monthList = this.computeMonth()
    this.currentMonth = this.from === 'start' ? this.monthList[0].value : this.monthList[this.monthList.length - 1].value
    this.dateList = this.computeDate(
      `${this.currentYear}-${this.currentMonth}-01`
    )
    this.currentDate = this.from === 'start' ? this.dateList[0].value : this.dateList[this.dateList.length - 1].value
    this.init()
  }
}
</script>
